export * from "./fetch-driver-slab";
